import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensor-group-sensors-view" }

import { ref, onMounted, computed } from 'vue'
import { useSensorGroupSensorStore } from './store'
import { SensorGroupSensor } from './models/sensorGroupSensor'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorGroupSensorsView',
  setup(__props) {

const sensorGroupSensorStore = useSensorGroupSensorStore()
const loading = ref(false)
const selectedGroupId = ref<string | null>(null)
const selectedSensorId = ref<string | null>(null)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Grupo ID', key: 'groupId' },
  { title: 'Sensor ID', key: 'sensorId' },
  { title: 'Posición', key: 'position' },
  { title: 'Creado', key: 'createdAt' },
  { title: 'Creado por', key: 'createdBy' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

// Opciones para los filtros (en un caso real, estos vendrían de otros stores)
const groupOptions = ref([
  { title: 'Grupo 1', value: 'group1' },
  { title: 'Grupo 2', value: 'group2' },
  { title: 'Grupo 3', value: 'group3' },
])

const sensorOptions = ref([
  { title: 'Sensor A', value: 'sensorA' },
  { title: 'Sensor B', value: 'sensorB' },
  { title: 'Sensor C', value: 'sensorC' },
])

const sensorGroupSensorsList = computed(() => {
  let list = sensorGroupSensorStore.sensorGroupSensors
  
  if (selectedGroupId.value) {
    list = list.filter(item => item.groupId === selectedGroupId.value)
  }
  
  if (selectedSensorId.value) {
    list = list.filter(item => item.sensorId === selectedSensorId.value)
  }
  
  // Ordenar por posición dentro de cada grupo
  return list.sort((a, b) => {
    if (a.groupId === b.groupId) {
      return a.position - b.position
    }
    return a.groupId.localeCompare(b.groupId)
  })
})

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorGroupSensorStore.getSensorGroupSensors()
  } finally {
    loading.value = false
  }
}

const filterByGroup = async (groupId: string | null) => {
  if (groupId) {
    loading.value = true
    try {
      await sensorGroupSensorStore.getSensorGroupSensorsByGroupId(groupId)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterBySensor = async (sensorId: string | null) => {
  if (sensorId) {
    loading.value = true
    try {
      await sensorGroupSensorStore.getSensorGroupSensorsBySensorId(sensorId)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const addItem = () => {
  // Implementar lógica para agregar relación
  console.log('Add new sensor group sensor relation')
}

const editItem = (item: SensorGroupSensor) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: SensorGroupSensor) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

const moveUp = async (item: SensorGroupSensor) => {
  if (item.position > 1) {
    // Lógica para mover hacia arriba
    const newPosition = item.position - 1
    console.log(`Moving sensor ${item.sensorId} up to position ${newPosition}`)
    // Aquí llamarías a la acción updateSensorPositions
  }
}

const moveDown = async (item: SensorGroupSensor) => {
  // Lógica para mover hacia abajo
  const newPosition = item.position + 1
  console.log(`Moving sensor ${item.sensorId} down to position ${newPosition}`)
  // Aquí llamarías a la acción updateSensorPositions
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("h1", null, "Sensor Group Sensors", -1),
                _createElementVNode("p", null, "Gestión de relaciones entre grupos de sensores y sensores", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedGroupId.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((selectedGroupId).value = $event)),
                    filterByGroup
                  ],
                  items: groupOptions.value,
                  label: "Filtrar por Grupo",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedSensorId.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selectedSensorId).value = $event)),
                    filterBySensor
                  ],
                  items: sensorOptions.value,
                  label: "Filtrar por Sensor",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: sensorGroupSensorsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("Lista de Sensores por Grupo")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Agregar Relación "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.groupId": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.groupId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.sensorId": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "green",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.sensorId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.position": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "orange",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" #" + _toDisplayString(item.position), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.createdAt": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.createdAt)), 1)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (moveUp(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-arrow-up")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (moveDown(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-arrow-down")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("mdi-pencil")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-delete")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})